import React from "react";
import { Button } from "@gcs/design-system/react";

import * as S from "./SectionLearnAboutOurProgram.Style";

const SectionLearnAboutOurProgram = () => {
  const handleClickPdf = (url) => {
    if (!url) return;

    window.open(url, "_blank");
  };

  return (
    <S.SectionLearnAboutOurProgramContainer>
      <S.SectionLearnAboutOurProgramContent className="container">
        <S.SectionLearnAboutOurProgramBlock>
          <S.SectionLearnAboutOurProgramBlockTitle>
            Conheça nosso Programa de Integridade
          </S.SectionLearnAboutOurProgramBlockTitle>

          <S.SectionLearnAboutOurProgramBlockDescription>
            Baixe o conteúdo sobre o nosso Programa de Integridade em formato
            PDF. Disponível em português e inglês, o documento apresenta ações e
            medidas que adotamos para combater a corrupção e garantir a ética, a
            transparência e o cumprimento das leis e regulamentos vigentes.
          </S.SectionLearnAboutOurProgramBlockDescription>
        </S.SectionLearnAboutOurProgramBlock>

        <S.SectionLearnAboutOurProgramActions>
          <Button
            role="link"
            className="primary"
            onClick={() =>
              handleClickPdf(
                "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Programa_de_Integridade_CNP_Seguros_Holding_Brasil.pdf",
              )
            }
          >
            PDF em português
          </Button>
          <Button
            role="link"
            className="outlined"
            variant="outlined"
            onClick={() =>
              handleClickPdf(
                "https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Programa_de_Integridade_CNP_Seguros_Holding_Brasil_English.pdf",
              )
            }
          >
            PDF em inglês
          </Button>
        </S.SectionLearnAboutOurProgramActions>
      </S.SectionLearnAboutOurProgramContent>
    </S.SectionLearnAboutOurProgramContainer>
  );
};

export default SectionLearnAboutOurProgram;
